// Centralized icon mapping for sidebar and tab bars
// Returns lucide-react/dynamic IconName strings

export const getIconForLabel = (label: string): string => {
  const map: Record<string, string> = {
    // Group headers
    Portfolio: "wallet",
    OnChain: "link",
    Overview: "home",
    Sectors: "pie-chart",
    Screener: "scan-search",
    Tokens: "coins",
    "Token Screener": "scan-search",
    "Social Sentiment & News": "newspaper",
    "Traditional Assets": "landmark",
    Macro: "globe",
    Analysis: "bar-chart-3",
    Research: "book-open",
    Assistant: "sparkles",
    "AI Assistant": "sparkles",
    Indices: "target",

    // Top-level
    "Market Overview": "globe",
    "My Dashboard": "layout-dashboard",
    Home: "home",
    Bitcoin: "bitcoin",
    "CEX Tokens": "banknote",
    "Bitcoin Ecosystem": "layers",
    "Core Blockchain Layers": "cpu",
    DeFi: "coins",
    Stablecoins: "circle-dollar-sign",
    "Real World Assets": "building-2",
    "Infrastructure & Middleware": "server",
    "Emerging Sectors": "flask-conical",
    Miscellaneous: "package-2",
    "ETFs and Investors": "building-2",
    "Investor and Institutional": "building",

    // Core Blockchain Layers
    "Layer 1": "cpu",
    "Layer 2": "layers",
    "Data Availability": "database",

    // DeFi
    DEXs: "refresh-cw",
    "Lending & Borrowing": "credit-card",
    "Yield Farming": "trending-up",
    Aggregators: "shuffle",
    Perpetuals: "bar-chart-3",
    "Liquid Staking": "lock",
    Protocols: "layers",
    "Staked Assets": "coins",
    "Other DeFi": "more-horizontal",

    // Stablecoins
    "Stablecoin Protocols": "settings",
    "Stablecoin Assets": "coins",
    "Stablecoins (Yield Bearing)": "trending-up",
    "Yield Bearing Stablecoins": "trending-up",

    // Real World Assets
    "RWA Protocols": "building-2",
    Commodities: "package",
    "Global Bonds": "file-text",
    "Institutional Funds": "briefcase",
    "Private Credit": "credit-card",
    Stocks: "trending-up",

    // Infrastructure & Middleware
    Oracles: "eye",
    "Interoperability/Bridges": "link",
    Bridges: "link",
    Indexing: "search",
    "Wrapped Assets": "package",
    Identity: "fingerprint",

    // Emerging
    AI: "brain",
    "Gaming & GameFi": "gamepad-2",
    SocialFi: "users",
    Privacy: "shield",
    DePIN: "wifi",
    GPUs: "cpu",
    Mapping: "map-pin",
    Telecom: "phone-call",
    "Storage/File Sharing": "hard-drive",
    "Storage & File Sharing": "hard-drive",

    // Bitcoin Ecosystem
    "Sidechains & Bitcoin L2s": "layers",
    Forks: "git-branch",

    // Other groups
    ETFs: "bar-chart-2",
    Investors: "users",
    "Economic Data": "bar-chart-3",
    "Market Sentiment": "gauge",
    "Technical Analysis": "line-chart",
    Sentiment: "message-circle",
    "Youtube Insights": "video",
    // Miscellaneous children
    Memecoins: "smile",
    "Memecoin Platforms": "rocket",
    Other: "more-horizontal",

    // Token Screener
    "All Tokens": "layout-grid",
    Charts: "line-chart",
    Movers: "trending-up",
    Compare: "bar-chart-horizontal-big",
    Watchlists: "bookmark",
    Alerts: "bell",

    // Chart Types
    Scatter: "scatter-chart",
    Heatmap: "grid-3x3",
    Ranking: "bar-chart-3",
    Correlation: "git-merge",
    Treemap: "layout-grid",
    Parallel: "align-horizontal-justify-center",

    // Sector Compare
    "Sector Compare": "bar-chart-horizontal-big",

    // Macro subtabs
    Economy: "trending-up",
    "Fed Rates": "percent",
    Correlations: "git-merge",
    FX: "banknote",

    // Sector Screener
    "All Sectors": "grid-2x2",

    // Portfolio subcategories (using label "Portfolio Overview" if needed)
    Metrics: "table",

    // Preferences
    Preferences: "settings",
    "Preferences Form": "clipboard-list",

    "Twitter Insights": "twitter",
    Twitter: "twitter",
    YouTube: "youtube",
    News: "newspaper",
    Trade: "candlestick-chart",
    About: "info",

    // Research reorganization
    "Social & News": "share-2",
    Indicators: "activity",
    "Market Indicators": "activity",
    Workspace: "layout-dashboard",
    "My Dashboards": "layout-dashboard",
    Dashboards: "layout-dashboard",
    Sheets: "table-2",
    "My Sheets": "table-2",
    "ETF Analytics": "bar-chart-2",
  };
  return map[label] ?? "dot";
};
